import InstrumentInfoModal from './InstrumentInfoModal';

export default InstrumentInfoModal;
